export default "__VITE_ASSET__ce2d08a0__"